import {
  constants,
  typographyStyles,
  mediaQueryStyles,
} from "@newsela/angelou";

const { ui } = constants.colors;
const { heading2 } = typographyStyles;
const { BreakpointNames } = constants.breakpoints;
const { mediaQuery: mq } = mediaQueryStyles;

export const containerCss = {
  flex: "1 1 353px",
};

export const contentContainerCss = {
  display: "flex",
  gap: 8,
  flexDirection: "column",
  marginBottom: 24,
  textAlign: "left",
};

export const headerContainerCss = {
  marginBottom: 24,
};

export const headerParagraphCss = {
  textAlign: "center",
  margin: "0 0 24px 0",
  color: ui.neutral[700],
  lineHeight: 1.2,
  "& a": {
    color: ui.core[700],
    padding: 0,
  },
};

export const paragraphContainerCss = {
  textAlign: "center",
};

export const paragraphCss = {
  ...headerParagraphCss,
  margin: 0,
  lineHeight: 1.2,
};

export const subHeaderCss = {
  ...heading2,
  textAlign: "center",
  color: ui.neutral[600],
  lineHeight: 1.1,
  margin: "0 0 8px 0",
};

export const accordionCss = {
  root: {
    border: `1px solid ${ui.neutral[100]}`,
    borderRadius: 4,
    Button: {
      padding: "12px 16px",
      minHeight: 48,
      [mq.downTo(BreakpointNames.xs)]: {
        padding: "8px 16px",
      },
      "& div": {
        textAlign: "start",
        lineHeight: 1.5,
        margin: "0 16px 0 0",
      },
      "&:hover, &:focus-visible": {
        backgroundColor: ui.white[50],
      },
    },
  },
  header: {
    "& + div::after": {
      display: "none",
    },
  },
  panel: {
    padding: 8,
    "&:not([hidden])": {
      display: "flex",
      flexDirection: "column",
      gap: 8,
    },
  },
};

export const accordionAnchorCss = {
  root: {
    border: "none",
    justifyContent: "flex-start",
    height: 56,
    padding: "8px 16px 8px 8px",
    "& > div": {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      lineHeight: 1.2,
      width: "100%",
      [mq.downTo(BreakpointNames.md)]: {
        lineHeight: 1,
      },
      "& > svg": {
        width: 24,
        height: 24,
      },
    },
  },
};

export const accordionContentCss = {
  display: "inline-flex",
  alignItems: "center",
  gap: 8,
  color: ui.neutral[700],
  [mq.downTo(BreakpointNames.md)]: {
    gap: 4,
  },
  iconContainer: {
    maxWidth: 40,
    maxHeight: 40,
    "& svg": {
      width: "100%",
    },
  },
};
